import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { CampaignContext } from '../../../../../../contexts/CampaignContext'
import CampaignScenario from './CampaignScenario'

export default observer(function CampaignScenarios() {
  const { campaignScenarios } = useContext(CampaignContext)
  const primaryScenario = campaignScenarios[0]

  if (!primaryScenario) return null

  return (
    <div className="border-1 dark:border-rb-dark-mode-lighter rounded-md p-4 mt-4">
      <p className="text-sm font-bold mb-4 dark:text-white">Budget table / Project timeline</p>
      <div className="flex flex-wrap gap-4">
        <CampaignScenario campaignScenario={primaryScenario} visibilityKind="budget" />
        <CampaignScenario campaignScenario={primaryScenario} visibilityKind="timeline" />
      </div>
    </div>
  )
})
